module.exports = __webpack_public_path__ + "static/media/piano-g.030339b0.wav";